interface WordmarkProps {
  /** Font-size in px.  Affects the dot size proportionally. */
  size?: number;
  /** When true, render the dot in white (for use on coloured surfaces). */
  inverse?: boolean;
}

/**
 * Prism wordmark.  The dot of the "i" is replaced by a brand-green square
 * — the only place green is used as branding (everywhere else green is
 * reserved for status/success).  The whole mark is wrapped in
 * aria-hidden so callers must label the surrounding link / button with
 * aria-label="Prism" themselves.  This avoids the screen-reader hostile
 * "P-r-dotless-i-s-m" pronunciation the previous decorative version had.
 */
export function Wordmark({ size = 26, inverse = false }: WordmarkProps) {
  const dotSize = Math.round(size * 0.22);
  const dotColor = inverse ? 'bg-white' : 'bg-[var(--color-success)]';
  const inkColor = inverse ? 'text-white' : 'text-[var(--color-ink)]';

  return (
    <span aria-hidden="true" className={['inline-flex items-baseline', inkColor].join(' ')}>
      <span
        className="font-sans font-bold leading-none tracking-[-0.025em]"
        style={{ fontSize: `${size}px` }}
      >
        Pr
      </span>
      {/* i with replaced dot */}
      <span
        className="relative font-sans font-bold leading-none tracking-[-0.025em]"
        style={{ fontSize: `${size}px` }}
      >
        ı
        <span
          aria-hidden="true"
          className={['absolute left-1/2 -translate-x-1/2 rounded-[1px]', dotColor].join(' ')}
          style={{
            width: `${dotSize}px`,
            height: `${dotSize}px`,
            top: `-${Math.round(dotSize * 0.4)}px`,
          }}
        />
      </span>
      <span
        className="font-sans font-bold leading-none tracking-[-0.025em]"
        style={{ fontSize: `${size}px` }}
      >
        sm
      </span>
    </span>
  );
}
